
export default class HorarioTabelaDiaSemana {

    diaSemana: number;
    descricao: string;
    entrada1: number;
    saida1: number;
    entrada2: number;
    saida2: number;

    constructor(
        diaSemana = 0,
        descricao = '',
        entrada1 = 0,
        saida1 = 0,
        entrada2 = 0,
        saida2 = 0,
    ) {
        this.diaSemana = diaSemana;
        this.descricao = descricao;
        this.entrada1 = entrada1;
        this.saida1 = saida1;
        this.entrada2 = entrada2;
        this.saida2 = saida2;
    }
}
